const TopBar = ({ section, unit, instruction }) => {
  return (
    <div className="mb-3 py-3 px-2 bg-white topBar text-md min-h-[45px]">
      <p className="unit">{section == "reading" ? "Passage " + unit : "Part " + unit}</p>
      <p className="instruction">  {instruction || ""}</p>
    </div>
  );
};

export default TopBar;
